import { contractorList } from "constants/contractor";

const initialState = {
  contractorList: {},
};

const contractor = (state = initialState, action) => {
  switch (action.type) {
    case contractorList:
      return { ...state, contractorList: action.payload };

    default:
      return state;
  }
};
export default contractor;
